// Generated by ReScript, PLEASE EDIT WITH CARE

import * as VerifyOtpApiModel from "../api-model/VerifyOtpApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function decodeApiModel(json) {
  return {
          message: json.message
        };
}

function execute(json) {
  var json$1 = DeccoUtils$Catalyst.resolveResult(VerifyOtpApiModel.t_decode(json), "VerifyOtpEntityMapper.re");
  return {
          message: json$1.message
        };
}

export {
  decodeApiModel ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
